import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { SearchField, Button } from '@gerdau/hefesto';
import {
  loadLoyaltyProduct,
  loadLoyaltyProductSimulate
} from '../../../../store/ducks/loyalty/actions';
import {
  ILoyaltyProduct,
  ILoyaltyProductList,
  ILoyaltyProductListToSend
} from '../../../../store/ducks/loyalty/types';
import { SearchContainer } from './styles';

export interface ISearchItem {
  id: string;
  label: string;
}

interface SearchProductProps {
  addProductToProductList: (product: ILoyaltyProduct) => void;
  productList: ILoyaltyProductList[];
}

const SearchProduct: React.FC<SearchProductProps> = ({
  addProductToProductList,
  productList
}) => {
  const loyalty = useSelector((appState: ApplicationState) => appState.loyalty);
  const dispatch = useDispatch();

  const getAllProducts = (): ISearchItem[] => {
    const productArray: ISearchItem[] = [];
    if (
      !loyalty.product.error ||
      !loyalty.product.loading ||
      loyalty.product.product_search.length > 0
    ) {
      loyalty.product.product_search.map((item) => {
        productArray.push({
          id: item.sku,
          label:
            item.sku + ' - ' + item.description + ' - ' + item.activitySector
        });
      });
    }
    return productArray;
  };

  const allProducts: ISearchItem[] = getAllProducts();

  const [searchedProducts, setSearchedProducts] = useState<ISearchItem[]>([]);

  useEffect(() => {
    setSearchedProducts(allProducts);
  }, [!loyalty.product.loading]);

  const user = useSelector((appState: ApplicationState) => appState.user);
  return (
    <SearchContainer>
      <div className="search-field">
        <SearchField
          label="Adicionar Produtos"
          name="inputSeatch"
          onChange={(e) => {
            if (e.target.value.length > 5) {
              dispatch(loadLoyaltyProduct(e.target.value.toString()));
            }
          }}
          searchResultOptions={searchedProducts}
          onSelectResultOption={(selectedItem: ISearchItem) => {
            const productData = selectedItem.label.split(' - ');
            const productToAdd: ILoyaltyProduct = {
              sku: productData[0],
              description: productData[1],
              activitySector: productData[2]
            };
            addProductToProductList(productToAdd);
          }}
          placeholder="Digite o SKU do produto"
        />
      </div>
      <div className="button-container">
        <Button
          fullWidth
          name="simulateButton"
          type="button"
          disabled={productList.length < 1 || loyalty.simulate.loading}
          onClick={() => {
            const newProductList: ILoyaltyProductListToSend[] = [];
            const auxProductList = JSON.parse(
              JSON.stringify(productList)
            ) as ILoyaltyProductList[];
            auxProductList.map((item) => {
              if (item.qty_type == 'kg') {
                item.qty = item.qty / 1000;
                item.qty_type = 'tn';
              }
              newProductList.push({
                sku: item.product.sku,
                qty: item.qty,
                activity_sector: item.product.activitySector
              });
            });
            dispatch(
              loadLoyaltyProductSimulate(
                user.roles.loyaltyCustomers &&
                  user.roles.loyaltyCustomers.length > 0
                  ? user.roles.loyaltyCustomers[0]
                  : '',
                newProductList
              )
            );
          }}
        >
          {loyalty.simulate.loading ? 'Simulando' : 'Simular'}
        </Button>
      </div>
    </SearchContainer>
  );
};

export default SearchProduct;
